module.exports = __webpack_public_path__ + "img/5.04.thmb.xs.644ba53d.jpg";